// export const DisplayVoucher = () => import('./displayVoucher');
// export const LedgerItemsDetails = () => import('./LedgerItemsDetails');
export const LedgerDetails = () => import("./LedgerDetails.vue");
export const MyPending = () => import("./MyPending.vue");
export const MonthlyLedger = () => import("./MonthlyLedger.vue");
// export const LedgerTransactionDetails = () => import('./LedgerTransactionDetails');
// export const MyBillDetails = () => import('./MyBillDetails');
// export const CompanyWiseBill = () => import('./CompanyWiseBill');
// export const OfficerBill = () => import('./OfficerBill');

export const Stock = () => import("./Stock.vue");

// export const List = () => import('./List');
// export const Sales = () => import('./Sales');
// export const ProductionCost = () => import('./ProductionCost');
export const DayBook = () => import("./DayBook.vue");
export const Groups = () => import("./Groups.vue");
export const GroupLedger = () => import("./GroupLedger.vue");
export const MonthlyIncomeExpense = () => import("./MonthlyIncomeExpense.vue");
export const BankInOut = () => import("./BankInOut.vue");
// export const ItemsVoucherDetails = () => import('./ItemsVoucherDetails');
// export const AuditList = () => import('./Audit/DataTable');
// export const AuditSheet = () => import('./Audit/AuditSheet');
// export const AuditStock = () => import('./Audit/StockDataTable');
// export const AuditAsset = () => import('./Audit/AssetDataTable');
// export const AuditSheetMonthly = () => import('./Audit/AuditSheetMonthly');
